export function formatDurationToMinutes(durationTimeMillis: number) {
    const durationMinutes = durationTimeMillis / 1000 / 60
    if (durationTimeMillis === 0) return '0'
    const roundedDuration = Math.round(durationMinutes)
    if (roundedDuration === 0) return '<1'
    return roundedDuration
}
